<template>
  <div>
    <div
      v-if="total > 0 && device === 1"
      :class="['pagination-container', { 'pagination-container--limited': showRealTotal }]"
    >
      <span v-if="showRealTotal" class="pagination-real-total">共 {{ total }} 条</span>
      <el-pagination
        :background="background"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :layout="effectiveLayout"
        :page-sizes="effectivePageSizes"
        :total="paginationTotal"
        v-bind="$attrs"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div v-if="total > 0 && device === 2" class="pagination-container-wap">
      <el-pagination
        :background="background"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        layout="prev, pager, next"
        :total="paginationTotal"
        v-bind="$attrs"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scrollTo'
import { mapGetters } from 'vuex'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [5, 10, 20, 50, 100, 500, 1000]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    maxTotal: {
      type: Number,
      default: 10000
    }
  },
  computed: {
    ...mapGetters(['device']),
    hasMaxTotalLimit() {
      return typeof this.maxTotal === 'number' && this.maxTotal > 0
    },
    layoutItems() {
      return this.layout.split(',').map((item) => item.trim())
    },
    showRealTotal() {
      return this.hasMaxTotalLimit && this.layoutItems.includes('total')
    },
    paginationTotal() {
      return this.hasMaxTotalLimit ? Math.min(this.maxTotal, this.total) : this.total
    },
    effectivePageSizes() {
      if (!this.hasMaxTotalLimit) {
        return this.pageSizes
      }
      return this.pageSizes.filter((size) => size <= this.maxTotal)
    },
    effectiveLayout() {
      if (!this.hasMaxTotalLimit) {
        return this.layout
      }
      return this.layoutItems.filter((item) => item !== 'total' && item !== 'jumper').join(', ')
    },
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val // 强制设置pageSize
      this.$emit('update:page', 1)
      this.$emit('pagination', { page: 1, pageSize: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, pageSize: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.pagination-container {
  padding: 32px 0px;
  text-align: right;
  overflow-x: auto;
  .el-pagination__total,
  .el-pagination__sizes {
    float: left;
  }
  .pagination-container.hidden {
    display: none;
  }
}
.pagination-container-wap {
  padding: 14px 0px;
  text-align: left;
  overflow-x: auto;
  .el-pagination__total,
  .el-pagination__sizes {
    float: left;
  }
  .pagination-container.hidden {
    display: none;
  }
}
.pagination-container--limited {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  .pagination-real-total {
    color: #606266;
    font-size: 13px;
    line-height: 28px;
  }
  .el-pagination__total,
  .el-pagination__sizes {
    float: none;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/Pagination/index.vue"
}
</vue-filename-injector>
